{
    "coordinates": [
        44.3548524714939,
        -100.39038870478389
    ],
    "tooltip": "Pierre Shale",
    "title": "Pierre Shale",
    "country": "United States",
    "period": "Cretaceous",
    "alt": "TODO"
}
